import { GetterTree } from 'vuex'
import { ListsState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<ListsState, RootState> = {
    templatesStatusList:state => state.templatesStatusList,
    messagesStatusList:state => state.messagesStatusList,
    smsMessagesStatusList: state => state.smsMessagesStatusList,
    callMessagesStatusList: state => state.callMessagesStatusList,
    pushMessagesStatusList: state => state.pushMessagesStatusList,
    emailMessagesStatusList: state => state.emailMessagesStatusList,
    viberMessagesStatusList: state => state.viberMessagesStatusList,
    customMessagesStatusList: state => state.customMessagesStatusList,
    whatsappMessagesStatusList: state => state.whatsappMessagesStatusList,
    mnMessagesStatusList:state => state.mnMessagesStatusList,
    priorityList:state => state.priorityList,
    deliveryTypeList:state => state.deliveryTypeList,
    originatorStatusList:state => state.originatorStatusList,
    smsFilterConditionsList:state => state.smsFilterConditionsList,
    delimiterList:state => state.delimiterList,
    restrictionsList:state => state.restrictionsList,
    devicesList:state => state.devicesList,
    personalisationList:state => state.personalisationList,
    xiaomiRegionList:state => state.xiaomiRegionList,
    positionList:state => state.positionList,
    timezonesList:state => state.timezonesList,
    eventTypeList:state => state.eventTypeList,
    cdpStatusList:state => state.cdpStatusList
};
